import React, { useState, useEffect ,useRef} from 'react';
import { Card, Modal, Button, Form, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faTrashAlt, faPlus } from '@fortawesome/free-solid-svg-icons';
import APICom from '../../utils/helpers/APICom';

const AlgoSettingsComponent = ({ AffiliateID, SettingType, onDataChange }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [algoSettings, setAlgoSettings] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false); // Added state for Add Modal
  const [editedSetting, setEditedSetting] = useState(null);
  const[showInActive,setShowInActive]=useState(false);
  const xCancelSourceForGrid = useRef(null);
  
  const [newSetting, setNewSetting] = useState({
    Name: '',
    Routes: '',
    Priority: '',
    'Is Default': false,
    SettingType: '0',
    bActive: true,
  });

  const openModal = () => {
    setIsModalOpen(true);
  };

  const savePriority=async ()=>{
    try {
      for (let item of sortedAlgoSettings) {
      // Perform operations on each item
        console.log(item);
        let qstr=`api/Settings/UpdateAlgoSettingPriority?iSettingID=${item.iSettingID}&iAlgoPriority=${item.Priority}`;
        const response = await APICom.fetchData(
          'GenericManifestDotNetCoreURL',
          qstr,
          'get',
        );
        if (response?.data) {      

        }
        else{
          alert(`setting Algo Priority Failed for ${item.Name}`);
        }
      }
      alert('Algo Priority set successfully')
      fetchAlgoSettings();


    } catch (error) {
      console.error('Error saving algo priority', error);
    }

  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const updateSettings = (newSettings) => {
    // setSortAlgoSettings(newSettings)
    setSortedAlgoSettings(newSettings);
    // setsortAlgoSettings(newSettings);
  };

  const [sortedAlgoSettings ,setSortedAlgoSettings] = useState([]);
  

  const handleDragStart = (event, index) => {
    event.dataTransfer.setData('index', index); // Store the dragged index
  };



  const handleDragOver = (event) => {
    event.preventDefault(); // Allow drop
  };

  const handleDrop = (event, targetIndex) => {
    event.preventDefault();
  
    const draggedIndex = event.dataTransfer.getData('index');
    if (draggedIndex === targetIndex) return; // No need to swap if the same item
  
    // Create a copy of the settings to avoid mutating the original state
    const newSettings = [...sortedAlgoSettings];
    const draggedItem = newSettings[draggedIndex];
  
    // Remove the dragged item from its original position
    newSettings.splice(draggedIndex, 1);
  
    // Insert the dragged item at the target index
    newSettings.splice(targetIndex, 0, draggedItem);
  
    // Reassign priorities based on the new order
    newSettings.forEach((setting, index) => {
      setting.Priority = index + 1; // Recalculate priority to reflect the order
    });
  
    // Update the state with the new settings
    updateSettings(newSettings);
  };
  

  const fetchAlgoSettings = async () => {
    try {
      if (AffiliateID !== '' && AffiliateID !== -1) {
        let qstr=`api/Settings/GetMVRouteGeneralSettings?affiliate_id=${AffiliateID}&iSettingType=${SettingType}&bActive=${!showInActive}`;
        const response = await APICom.fetchData(
          'GenericManifestDotNetCoreURL',
          qstr,
          'get',
        );
        if (response?.data) {
          setAlgoSettings(response.data);
          // const tempData=JSON.parse(JSON.stringify(response.data));
          // const sortedData = tempData.Table.sort((a, b) => b.Priority - a.Priority);
          // console.log(sortedData);
          // setSortedAlgoSettings(sortedData);
          

        }
      }
      else{
        setAlgoSettings([]);

      }
    } catch (error) {
      console.error('Error fetching algo settings', error);
    }
  };

  useEffect(() => {
    fetchAlgoSettings();
  }, [AffiliateID,showInActive]);

  useEffect(() => {
    if (algoSettings && algoSettings.Table && algoSettings.Table.length > 0) {
      const element=algoSettings.Table.find(item => item['Is Default'] === true);
      if (element) {
        // Code to execute if a matching element is found
        handleDataUpdate(element.Name,element.iSettingID);
    }
    else{
      handleDataUpdate(algoSettings.Table[0].Name,algoSettings.Table[0].iSettingID);
    }
    } else {
      setSelectedRow(null);
    }
  }, [algoSettings]);

  const handleDataUpdate = (iSettingName, iSettingID) => {
    setSelectedRow(iSettingID);
    onDataChange(iSettingName, iSettingID);
    setIsOpen(false);
  };

  const handlePencilClick = (e, item) => {
    e.stopPropagation();
    setEditedSetting(item);
    setShowEditModal(true); // Open Edit Modal
  };

  const handleTrashClick = async (e, item) => {
    e.stopPropagation();
    alert(`Are you sure to Delete ${item.Name}?`);
    try {

        const response = await APICom.fetchData(
          'GenericManifestDotNetCoreURL',
          `api/Settings/RemoveAlgoSetting?iSettingID=${item.iSettingID}`,
          'get'
        );
        if (response?.data) {
          alert('setting deleted successfully');
          fetchAlgoSettings();
        }
        else{
          alert('setting deletion failed')
        }

    } catch (error) {
      console.error('Error deleting algo settings', error);
    }
  };

  const handleAddSetting = async () => {
    if(!newSetting.Name || newSetting.Name==''){
      alert('enter setting name');
      return;
    }
    alert(`Adding new setting: ${newSetting.Name}`);
    try {
      const payload = {
        iAffiliateID:AffiliateID,
        vSettingsName: newSetting.Name||'',
        bActive:newSetting.bActive||false,
        bDefault:newSetting['Is Default']||false,
        iSettingtype:parseInt(SettingType)||0
      };
      xCancelSourceForGrid.current = APICom.GenerateSource();
      let response=await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Settings/AddAlgoSetting", "post", {}, payload, xCancelSourceForGrid.current);
    if (response?.data) {
      alert('setting added successfully');
      setShowAddModal(false); // Close Add Modal
      setNewSetting({ ...newSetting,
        Name: '',
        Routes: '',
        Priority: '',
        'Is Default': false,
        SettingType: '0',
        bActive: true,
      });
      fetchAlgoSettings();
    }
    else{
      alert('setting adding failed')
    }

} catch (error) {
  console.error('Error adding algo settings', error);
}

};

  const handleEditSave = async () => {
    alert(`are you sure to update setting  ${editedSetting.Name}`);
    try {
        const payload = {
          iSettingID: editedSetting.iSettingID||-1,
          vSettingsName: editedSetting.Name||'',
          bActive:editedSetting.bActive||false,
          bDefault:editedSetting['Is Default']||false,
          iSettingtype:parseInt(editedSetting.SettingType)||0
        };
        xCancelSourceForGrid.current = APICom.GenerateSource();
        let response=await APICom.fetchData("GenericManifestDotNetCoreURL", "api/Settings/UpdateAlgoSetting", "post", {}, payload, xCancelSourceForGrid.current);
      if (response?.data) {
        alert('setting updated successfully');
        setShowEditModal(false); // Close Edit Modal
        setEditedSetting(null);
        fetchAlgoSettings();
      }
      else{
        alert('setting update failed')
      }

  } catch (error) {
    console.error('Error updating algo settings', error);
  }
 
  };

  const handleSettingTypeChange = (e) => {
    setEditedSetting({ ...editedSetting, SettingType: e.target.value });
  };

  const handleAddSettingTypeChange = (e) => {
    setNewSetting({ ...newSetting, SettingType: e.target.value });
  };

  const handleActiveChange = () => {
    setEditedSetting({ ...editedSetting, bActive: !editedSetting.bActive });
  };

  const handleAddActiveChange = () => {
    setNewSetting({ ...newSetting, bActive: !newSetting.bActive });
  };

  return (
    <Card className="mb-4">
      <Card.Body>
        <div className="table-responsive" style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
          <div
            className="custom-dropdown"
            style={{
              border: '1px solid #ccc',
              padding: '10px',
              borderRadius: '8px',
              backgroundColor: '#f8f9fa',
              position: 'relative',
              width: '100%',
              cursor: 'pointer',
            }}
            onClick={() => setIsOpen(!isOpen)}
          >
            <span>{selectedRow ? algoSettings?.Table?.find((item) => item.iSettingID === selectedRow)?.Name : 'Select Algorithm Setting'}</span>
            <div
              style={{
                position: 'absolute',
                top: '50%',
                right: '10px',
                transform: 'translateY(-50%)',
              }}
            >
              ▼
            </div>
          </div>

          {isOpen && (
            <div
              className="dropdown-options"
              style={{
                border: '1px solid #ccc',
                borderRadius: '8px',
                marginTop: '5px',
                maxHeight: '200px',
                overflowY: 'auto',
                backgroundColor: '#fff',
                zIndex: '9999',
              }}
            >
              <div
                className="dropdown-header"
                style={{
                  backgroundColor: '#add8e6',
                  fontWeight: 'bold',
                  padding: '12px',
                  textAlign: 'center',
                  fontSize: '14px',
                  color: '#555',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <span>
                  <strong>Name</strong> | <strong>Routes</strong> | <strong>Priority</strong> | <strong>Is Default</strong> | <strong>Setting Type</strong>
                </span>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                <button
                style={{
                  padding: '8px 16px', // Reduced padding to make it shorter
                  backgroundColor: '#6200ea', // Purple gradient color
                  color: 'white',
                  border: 'none',
                  borderRadius: '50px', // Makes the button round
                  fontSize: '14px', // Slightly smaller font size
                  fontWeight: 'bold',
                  textTransform: 'uppercase',
                  cursor: 'pointer',
                  marginRight: '10px',
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)', // Adding shadow for depth
                  transition: 'all 0.3s ease', // Smooth transition on hover
                }}
                onClick={() => {
                  if(!algoSettings?.Table?.length > 0){
                    alert('no settings are available');
                    return
                  }
                  // const tempData=JSON.parse(JSON.stringify(algoSettings));
                  // const sortedData = tempData?.Table?.sort((a, b) => b.Priority - a.Priority);
                  // console.log(sortedData);
                  // setSortedAlgoSettings(sortedData);
                  const tempData = JSON.parse(JSON.stringify(algoSettings));
                  const sortedData = tempData?.Table?.sort((a, b) => a.Priority - b.Priority); // Ascending order
                  console.log(sortedData);
                  setSortedAlgoSettings(sortedData);
                  openModal();
                  // Add your button click functionality here
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#3700b3'; // Darker purple on hover
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#6200ea'; // Revert to original purple
                }}
                
              >
                Set Priority
              </button>

                <Form.Check
                  type="checkbox"
                  label="Show Inactive"
                  checked={showInActive}
                  onChange={() => {setShowInActive(!showInActive);}}
                  style={{ marginRight: '10px' }}
                />
                <FontAwesomeIcon
                  icon={faPlus}
                  style={{
                    fontSize: '35px',
                    cursor: 'pointer',
                    color: 'red',
                  }}
                  onClick={() => {
                    console.log('-'+AffiliateID);
                    if(AffiliateID!==-1 && AffiliateID!==''){setShowAddModal(true)}else{alert('select an Affiliate first')}}} // Open Add Modal
                />
                 </div>
              </div>

              {Array.isArray(algoSettings?.Table) && algoSettings?.Table.length > 0 ? (
                algoSettings?.Table.map((item, index) => (
                  <div
                    key={index}
                    onClick={() => handleDataUpdate(item.Name, item.iSettingID)}
                    style={{
                      padding: '10px',
                      fontSize: '14px',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      backgroundColor: selectedRow === item.iSettingID ? '#cce5ff' : 'transparent',
                      cursor: 'pointer',
                    }}
                    onMouseEnter={(e) => (e.target.style.backgroundColor = '#e9ecef')}
                    onMouseLeave={(e) => (e.target.style.backgroundColor = selectedRow === item.iSettingID ? '#cce5ff' : 'transparent')}
                  >
                    {item.Name} | {item.Routes} | {item.Priority} | {item['Is Default'] ? 'True' : 'False'} | {item['Setting Type']}
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <FontAwesomeIcon
                        icon={faPencilAlt}
                        style={{
                          marginLeft: '8px',
                          color: '#007bff',
                          cursor: 'pointer',
                        }}
                        onClick={(e) => handlePencilClick(e, item)}
                      />
                      <FontAwesomeIcon
                        icon={faTrashAlt}
                        style={{
                          marginLeft: '8px',
                          color: '#dc3545',
                          cursor: 'pointer',
                        }}
                        onClick={(e) => handleTrashClick(e, item)}
                      />
                    </div>
                  </div>
                ))
              ) : (
                <div style={{ padding: '10px' }}>No algorithm settings available.</div>
              )}
            </div>
          )}
        </div>
      </Card.Body>

      {/* {isModalOpen && (
        <div
          style={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: '9999',
          }}
        >
          <div
            style={{
              backgroundColor: 'white',
              padding: '20px',
              width: '50%',
              borderRadius: '8px',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            }}
          >
            <h2>Settings</h2>
            <ul>
              {sortedAlgoSettings?.map((setting, index) => (
                <li
                  key={setting.iSettingID}
                  draggable
                  onDragStart={(e) => handleDragStart(e, index)}
                  onDrop={(e) => handleDrop(e, index)}
                  onDragOver={handleDragOver}
                  style={{
                    padding: '10px',
                    margin: '5px 0',
                    backgroundColor: '#f0f0f0',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    cursor: 'move',
                  }}
                >
                  <span>{setting.Name}</span> | <span>{setting.iAlgoPriority}</span>
                </li>
              ))}
            </ul>
            <button onClick={()=>{
              setSortedAlgoSettings([]);
              closeModal();
              }} style={{ marginTop: '20px' }}>
              Close
            </button>
          </div>
        </div>
      )} */}

{isModalOpen && (
  <div
    style={{
      position: 'fixed',
      top: '0',
      left: '0',
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.7)', // Darker background for better contrast
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: '9999',
      animation: 'fadeIn 0.3s ease', // Adding fade-in animation
    }}
  >
    <div
      style={{
        backgroundColor: 'white',
        padding: '30px',
        width: '60%',
        maxWidth: '600px',
        borderRadius: '12px',
        boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
        animation: 'zoomIn 0.3s ease-out', // Zoom-in animation
        overflowY: 'auto', // Allow scrolling if the list is long
      }}
    >
      <h2 style={{ fontSize: '24px', fontWeight: 'bold', color: '#333' }}>Settings</h2>
      
      <ul style={{ padding: '0', listStyleType: 'none', margin: '20px 0' }}>
        {sortedAlgoSettings?.map((setting, index) => (
          <li
            key={setting.iSettingID}
            draggable
            onDragStart={(e) => handleDragStart(e, index)}
            onDrop={(e) => handleDrop(e, index)}
            onDragOver={handleDragOver}
            style={{
              padding: '12px',
              margin: '8px 0',
              backgroundColor: '#f9f9f9',
              border: '1px solid #ddd',
              borderRadius: '8px',
              cursor: 'move',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              transition: 'background-color 0.3s ease',
            }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#e2e2e2'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#f9f9f9'}
          >
            <span style={{ fontSize: '16px', color: '#333' }}>{setting.Name}</span>
            {/* Remove priority number from display */}
          </li>
        ))}
      </ul>

      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
        <button
          onClick={() => {
            setSortedAlgoSettings([]); // Clear settings if needed
            closeModal();
          }}
          style={{
            padding: '10px 20px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '16px',
            transition: 'background-color 0.3s ease',
          }}
          onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#0056b3'}
          onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#007bff'}
        >
          Close
        </button>

        <button
          onClick={() => {
            // Logic to save the new priorities
            savePriority();
          }}
          style={{
            padding: '10px 20px',
            backgroundColor: '#28a745', // Green button for save
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '16px',
            transition: 'background-color 0.3s ease',
          }}
          onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#218838'}
          onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#28a745'}
        >
          Save Priority
        </button>
      </div>
    </div>
  </div>
)}

<Modal show={showAddModal} onHide={() => {
  setShowAddModal(false);
  setNewSetting({ ...newSetting,
  Name: '',
  Routes: '',
  Priority: '',
  'Is Default': false,
  SettingType: '0',
  bActive: true,
  });
  }} centered size="lg">
  <Modal.Header closeButton style={{ backgroundColor: '#f8f9fa', borderBottom: '2px solid #ccc' }}>
    <Modal.Title>Add New Setting</Modal.Title>
  </Modal.Header>
  <Modal.Body style={{ backgroundColor: '#f1f3f5', padding: '20px' }}>
    <Form>
      <Form.Group controlId="settingName" style={{ marginBottom: '20px' }}>
        <div className="d-flex align-items-center" style={{ marginBottom: '10px' }}>
          <Form.Label style={{ marginRight: '20px', width: '120px' }}>Name</Form.Label>
          <Form.Control
            type="text"
            value={newSetting.Name}
            onChange={(e) => setNewSetting({ ...newSetting, Name: e.target.value })}
            placeholder="Enter setting name"
            style={{
              borderRadius: '8px',
              fontSize: '16px',
              padding: '12px',
              maxWidth: '400px',
              flex: 1,
            }}
          />
        </div>
      </Form.Group>

      <Form.Group controlId="settingRoutes" style={{ marginBottom: '20px' }}>
        <div className="d-flex align-items-center" style={{ marginBottom: '10px' }}>
          <Form.Label style={{ marginRight: '20px', width: '120px' }}>Routes</Form.Label>
          <Form.Control
            type="number"
            value={newSetting.Routes}
            onChange={(e) => setNewSetting({ ...newSetting, Routes: e.target.value })}
            placeholder="Number of routes"
            style={{
              borderRadius: '8px',
              fontSize: '16px',
              padding: '12px',
              maxWidth: '400px',
              flex: 1,
            }}
            disabled
          />
        </div>
      </Form.Group>

      <Form.Group controlId="settingPriority" style={{ marginBottom: '20px' }}>
        <div className="d-flex align-items-center" style={{ marginBottom: '10px' }}>
          <Form.Label style={{ marginRight: '20px', width: '120px' }}>Priority</Form.Label>
          <Form.Control
            type="number"
            value="-1"
            // onChange={(e) => setNewSetting({ ...newSetting, Priority: e.target.value })}
            // placeholder="Enter priority"
            style={{
              borderRadius: '8px',
              fontSize: '16px',
              padding: '12px',
              maxWidth: '400px',
              flex: 1,
            }}
            disabled
          />
        </div>
      </Form.Group>

      <Form.Group controlId="settingIsDefault" style={{ marginBottom: '20px' }}>
        <div className="d-flex align-items-center" style={{ marginBottom: '10px' }}>
          <Form.Label style={{ marginRight: '20px', width: '120px' }}>Is Default</Form.Label>
          <Form.Check
            type="checkbox"
            label=""
            checked={newSetting.IsDefault}
            onChange={(e) => setNewSetting({ ...newSetting, 'Is Default': e.target.checked })}
            style={{ fontSize: '16px' }}
          />
        </div>
      </Form.Group>

      <Form.Group controlId="settingType" style={{ marginBottom: '20px' }}>
        <div className="d-flex align-items-center" style={{ marginBottom: '10px' }}>
          <Form.Label style={{ marginRight: '20px', width: '120px' }}>Setting Type</Form.Label>
          <Form.Control
            as="select"
            value={SettingType}
            onChange={handleAddSettingTypeChange}
            style={{
              width: '100%',
              borderRadius: '8px',
              padding: '12px',
              maxWidth: '400px',
              flex: 1,
            }}
            disabled
          >
            <option value="0">Default</option>
            <option value="1">Out Bound</option>
            <option value="2">In Bound</option>
            <option value="3">Fixed Route</option>
            <option value="4">Clustering</option>
            <option value="5">Delivery Routes</option>
            <option value="6">Microtransit</option>
          </Form.Control>
        </div>
      </Form.Group>

      <Form.Group controlId="settingIsActive" style={{ marginBottom: '20px' }}>
        <div className="d-flex align-items-center" style={{ marginBottom: '10px' }}>
          <Form.Label style={{ marginRight: '20px', width: '120px' }}>Active</Form.Label>
          <Form.Check
            type="checkbox"
            label=""
            checked={newSetting.bActive}
            onChange={handleAddActiveChange}
            style={{ fontSize: '16px' }}
          />
        </div>
      </Form.Group>
    </Form>
  </Modal.Body>
  <Modal.Footer style={{ backgroundColor: '#f8f9fa' }}>
    <Button variant="secondary" onClick={() => {setShowAddModal(false);

      setNewSetting({ ...newSetting,
        Name: '',
        Routes: '',
        Priority: '',
        'Is Default': false,
        SettingType: '0',
        bActive: true,
        });
    }} style={{ borderRadius: '8px', padding: '10px 20px' }}>
      Close
    </Button>
    <Button
      variant="primary"
      onClick={handleAddSetting}
      style={{ borderRadius: '8px', padding: '10px 20px' }}
    >
      Add Setting
    </Button>
  </Modal.Footer>
</Modal>


<Modal show={showEditModal} onHide={() => {setShowEditModal(false);setEditedSetting(null);}} centered size="lg">
  <Modal.Header closeButton style={{ backgroundColor: '#f8f9fa', borderBottom: '2px solid #ccc' }}>
    <Modal.Title>Edit Setting</Modal.Title>
  </Modal.Header>
  <Modal.Body style={{ backgroundColor: '#f1f3f5', padding: '20px' }}>
    <Form>
      <Form.Group controlId="settingName" style={{ marginBottom: '20px' }}>
        <div className="d-flex align-items-center" style={{ marginBottom: '10px' }}>
          <Form.Label style={{ marginRight: '20px', width: '120px' }}>Name</Form.Label>
          <Form.Control
            type="text"
            value={editedSetting ? editedSetting.Name : ''}
            onChange={(e) =>
              setEditedSetting({ ...editedSetting, Name: e.target.value })
            }
            placeholder="Enter setting name"
            style={{
              borderRadius: '8px',
              fontSize: '16px',
              padding: '12px',
              maxWidth: '400px',
              flex: 1,
            }}
          />
        </div>
      </Form.Group>

      <Form.Group controlId="settingRoutes" style={{ marginBottom: '20px' }}>
        <div className="d-flex align-items-center" style={{ marginBottom: '10px' }}>
          <Form.Label style={{ marginRight: '20px', width: '120px' }}>Routes</Form.Label>
          <Form.Control
            type="number"
            value={editedSetting ? editedSetting.Routes : ''}
            onChange={(e) =>
              setEditedSetting({ ...editedSetting, Routes: e.target.value })
            }
            placeholder="Enter number of routes"
            style={{
              borderRadius: '8px',
              fontSize: '16px',
              padding: '12px',
              maxWidth: '400px',
              flex: 1,
            }}
            disabled
          />
        </div>
      </Form.Group>

      <Form.Group controlId="settingPriority" style={{ marginBottom: '20px' }}>
        <div className="d-flex align-items-center" style={{ marginBottom: '10px' }}>
          <Form.Label style={{ marginRight: '20px', width: '120px' }}>Priority</Form.Label>
          <Form.Control
            type="number"
            value={editedSetting ? editedSetting.Priority : ''}
            onChange={(e) =>
              setEditedSetting({ ...editedSetting, Priority: e.target.value })
            }
            placeholder="Enter priority"
            style={{
              borderRadius: '8px',
              fontSize: '16px',
              padding: '12px',
              maxWidth: '400px',
              flex: 1,
            }}
            disabled
          />
        </div>
      </Form.Group>

      <Form.Group controlId="settingIsDefault" style={{ marginBottom: '20px' }}>
        <div className="d-flex align-items-center" style={{ marginBottom: '10px' }}>
          <Form.Label style={{ marginRight: '20px', width: '120px' }}>Is Default</Form.Label>
          <Form.Check
            type="checkbox"
            label=""
            checked={editedSetting ? editedSetting['Is Default'] : false}
            onChange={(e) =>
              setEditedSetting({ ...editedSetting, 'Is Default': e.target.checked })
            }
            style={{ fontSize: '16px' }}
          />
        </div>
      </Form.Group>

      <Form.Group controlId="settingType" style={{ marginBottom: '20px' }}>
        <div className="d-flex align-items-center" style={{ marginBottom: '10px' }}>
          <Form.Label style={{ marginRight: '20px', width: '120px' }}>Setting Type</Form.Label>
          <Form.Control
            as="select"
            value={editedSetting ? editedSetting.SettingType : ''}
            onChange={handleSettingTypeChange}
            style={{
              width: '100%',
              borderRadius: '8px',
              padding: '12px',
              maxWidth: '400px',
              flex: 1,
            }}
          >
            <option value="0">Default</option>
            <option value="1">Out Bound</option>
            <option value="2">In Bound</option>
            <option value="3">Fixed Route</option>
            <option value="4">Clustering</option>
            <option value="5">Delivery Routes</option>
            <option value="6">Microtransit</option>
          </Form.Control>
        </div>
      </Form.Group>

      <Form.Group controlId="settingIsActive" style={{ marginBottom: '20px' }}>
        <div className="d-flex align-items-center" style={{ marginBottom: '10px' }}>
          <Form.Label style={{ marginRight: '20px', width: '120px' }}>Active</Form.Label>
          <Form.Check
            type="checkbox"
            label=""
            checked={editedSetting ? editedSetting.bActive : true}
            onChange={handleActiveChange}
            style={{ fontSize: '16px' }}
          />
        </div>
      </Form.Group>
    </Form>
  </Modal.Body>
  <Modal.Footer style={{ backgroundColor: '#f8f9fa' }}>
    <Button variant="secondary" onClick={() => {setShowEditModal(false);setEditedSetting(null);}} style={{ borderRadius: '8px', padding: '10px 20px' }}>
      Close
    </Button>
    <Button
      variant="primary"
      onClick={handleEditSave}
      style={{ borderRadius: '8px', padding: '10px 20px' }}
    >
      Save Changes
    </Button>
  </Modal.Footer>
</Modal>


    </Card>
  );
};

export default AlgoSettingsComponent;
